function formatProductCode(product) {
  let code = product.code;
  if (product.codeVariant) {
    code = code + "-" + product.codeVariant;
  }
  return code;
}

export { formatProductCode };
